export const EMPLOYEE_GET_ALL = "V1_EMPLOYEE_GET_ALL";
export const EMPLOYEE_GET_ALL_BY_COID = "V1_EMPLOYEE_GET_ALL_BY_COID";
export const CREATE_EMPLOYEE = "V1_CREATE_EMPLOYEE";
export const UPDATE_EMPLOYEE = "V1_UPDATE_EMPLOYEE";
export const BULK_UPLOAD_EMPLOYEE = "V1_BULK_UPLOAD_EMPLOYEE";
export const UPDATE_REMARKCOUNT_EMPLOYEE = "V1_UPDATE_REMARKCOUNT_EMPLOYEE";
